import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, CustomLoader, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { ADD, FILTER, LIST } from "../../assets/icons";
import BossTable from "./component/BossTable";
import BossForm from "./component/BossForm";
import BossBlocageModal from "./component/BossBlocageModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { exportAsyncBoss } from "../../store/features/bossSlice";
import { useNavigate } from "react-router-dom";


function Boss() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formVisible, setFormVisible] = useState(false);
  const [motifVisible, setMotifVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const boss = useSelector((state: RootState) => Object.values(state.boss));

  const onOpenForm = () => {
    setFormVisible(true);
  };

  const onCloseForm = () => {
    setFormVisible(false);
  };

  const onOpenMotif = () => {
    setMotifVisible(true);
  };

  const onCloseMotif = () => {
    setMotifVisible(false);
  };

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const onDetail = (item: any) => {
    navigate("/boss/profile/" + item.id);
  };

  const callback = (resBlob: any) => {
    const url = window.URL.createObjectURL(new Blob([resBlob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `listeBoss.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode?.removeChild(link);
    setLoading(false);
  };

  const onExport = () => {
    toggleLoader();
    dispatch(exportAsyncBoss(callback) as any);
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_boss")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("creer_boss")}
            leftComponent={
              <SvgContainer svg={ADD} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            onClick={onOpenForm}
          />
          <CustomButton
            title={i18n.t("filtrer_par")}
            rightComponent={
              <SvgContainer
                svg={FILTER}
                color={theme.colors.white}
                width={15}
              />
            }
            titleStyle={{ marginRight: 1 }}
            rootStyle={{ backgroundColor: theme.colors.black, height: 45 }}
          />
          <CustomButton
            title={i18n.t("exporter_liste")}
            leftComponent={
              <SvgContainer svg={LIST} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            rootStyle={{ backgroundColor: "#3D423F", height: 45 }}
            onClick={onExport}
          />
        </Stack>
      </Stack>
      <BossTable data={boss} onBlock={onOpenMotif} onDetail={onDetail} />
      {formVisible ? (
        <BossForm open={formVisible} onClose={onCloseForm} />
      ) : null}
      <BossBlocageModal open={motifVisible} onClose={onCloseMotif} />
      <CustomLoader open={loading} handleClose={toggleLoader} />
    </Box>
  );
}

export default Boss;
